import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import {
  IonContent,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import RadioPlayableContent from './RadioPlayableContent'
import RadioBody from './RadioBody'
import RssReader from './RssReader'
import { setMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import {
  getProduct
} from '../../services/api/products'
import { radioSettings } from '../../config/pages'

const RadioProgram = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [product, setProduct] = useState(false)
  const [rssTrack, setRssTrack] = useState(false)
  const { hashid } = useParams()
  const [id, title] = hashid.split('_')
  const history = useHistory()

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setView(window.location.pathname)
    setPixelView()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  useEffect(() => {
    getProduct({
      id: id,
      title: title
    }).then((response) => {
      setProduct(response)
      setMetaTags({
        title: `${response.data.product} - ${response.data.category}  - Yok Radio`,
        keywords: `${radioSettings.keywords}, ${response.data.product}`,
        description: response.data.description,
        image: response.data.image_card,
        'image:width': 600,
        'image:height': 730
      })
    }).catch(() => {
      setProduct(false)
      history.push('/404')
    })
    return () => {
      setProduct(false)
    }
  }, [id, title])

  if (isVisible === false || product === false) return null

  return (
    <IonContent
      fullscreen
      className='radio-program-page page-wrapper'
    >
      {/* <RadioHeader rssTrack={rssTrack} product={product} /> */}

      {product.data.id_product_source === '1' && <RadioBody product={product} />}
      {product.data.id_product_source === '2' && <RadioPlayableContent product={product} />}
      {product.data.id_product_source === '3' && <RssReader product={product} setRssTrack={setRssTrack} />}
    </IonContent>
  )
}

export default RadioProgram
